import React, { FC } from 'react';
import { WithStyle } from '../../utils/with-style';
import TextStyled from './text.styled';
import TextProps from './types';

export const Text: FC<TextProps> & WithStyle = props => <TextStyled {...props} />;

Text.defaultProps = {
  $size: 'md',
  $color: 'primary',
  $fontWeight: 'normal',
  as: 'p',
};

Text.displayName = 'Text';
Text.Style = TextStyled;
